import { useCart } from "../context/CartContext";


export default function CartPage(){
const { cart, removeFromCart, updateQty } = useCart();
const total = cart.reduce((s,i)=> s + i.discountedPrice * i.qty, 0);


return (
<div className="max-w-5xl mx-auto p-4 pt-24">
<h1 className="text-2xl font-bold mb-4">Your Cart</h1>
{cart.length===0 ? <p>Your cart is empty.</p> : (
<div className="space-y-4">
{cart.map(item=> (
<div key={item.id} className="flex items-center gap-4 bg-white p-3 rounded shadow">
<img src={item.image} alt="" className="w-20 h-20 object-cover rounded" />
<div className="flex-1">
<h3 className="font-semibold">{item.name}</h3>
<p className="text-sm text-gray-500">₹{item.discountedPrice} x {item.qty} = ₹{item.discountedPrice*item.qty}</p>
</div>
<div className="flex items-center gap-2">
<button onClick={()=> updateQty(item.id, Math.max(1, item.qty-1))} className="px-2 py-1 border">-</button>
<div className="px-3">{item.qty}</div>
<button onClick={()=> updateQty(item.id, item.qty+1)} className="px-2 py-1 border">+</button>
<button onClick={()=> removeFromCart(item.id)} className="ml-4 text-red-500">Remove</button>
</div>
</div>
))}


<div className="text-right font-bold">Total: ₹{total}</div>
<div className="text-right"><button className="px-4 py-2 bg-indigo-600 text-white rounded">Proceed to Checkout</button></div>
</div>
)}
</div>
);
}